import {
    LuTrendingUp,
    LuTrendingDown,
    LuClipboardList,
    LuUndo2,
} from "react-icons/lu";
import { formatCurrency, formatThousands } from "@/utils";
import StatCard from "./StatCard";

const StatCardsRow = ({ stats, isLoading }) => {
    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
            <StatCard
                icon={<LuTrendingUp size={22} />}
                label="Total Penjualan (Bulan Ini)"
                tooltip="Total nilai semua pesanan penjualan bulan ini"
                value={stats?.total_sales}
                formatFn={formatCurrency}
                isLoading={isLoading}
                color="success"
            />
            <StatCard
                icon={<LuTrendingDown size={22} />}
                label="Total Pembelian (Bulan Ini)"
                tooltip="Total nilai semua pesanan pembelian bulan ini"
                value={stats?.total_purchases}
                formatFn={formatCurrency}
                isLoading={isLoading}
                color="primary"
            />
            <StatCard
                icon={<LuClipboardList size={22} />}
                label="Pesanan Aktif"
                tooltip="SO belum lunas + PO belum selesai"
                value={stats?.active_orders}
                formatFn={formatThousands}
                isLoading={isLoading}
                color="warning"
            />
            <StatCard
                icon={<LuUndo2 size={22} />}
                label="Retur Pending"
                tooltip="Retur yang menunggu persetujuan"
                value={stats?.pending_returns}
                formatFn={formatThousands}
                isLoading={isLoading}
                color="danger"
            />
        </div>
    );
};

export default StatCardsRow;
